import {Outlet} from "react-router-dom";


const InstructorHome = () => {
    return (
        <>
            {/*<div className="container">*/}
            {/*    <div className="content">*/}
                    <Outlet/>
                {/*</div>*/}
            {/*</div>*/}
        </>
    );
};

export default InstructorHome;
